module.exports = global.config = {
  host: "https://api-gateway.sampangkab.go.id/be-diskopindag",
  subdomain: "diskopindag",
};